(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jpi-events-blog"]) return;
  try {
    
  /* TIMESTAMP START 2026-10-25T19:35:41-04:00 | REVISION R000053 */
  async function initializeGroupedEventCatalog(root) {
    if (root.dataset.eventCatalogReady) return;
    root.dataset.eventCatalogReady = 'loading';
    const groupNames = ['current', 'upcoming', 'past', 'unknown'];
    const pageKeys = { current: 'ongoing_page', upcoming: 'upcoming_page', past: 'past_page', unknown: 'undated_page' };
    const items = new Map([...root.querySelectorAll('[data-event-id]')].map(card => [card.dataset.eventId, card]));
    try {
      for (let page = 1; page <= Number(root.dataset.sourcePages); page++) {
        if (page === Number(root.dataset.sourcePage)) continue;
        const url = new URL(location.href);
        url.searchParams.set('page', page);
        url.searchParams.delete('event_page');
        Object.values(pageKeys).forEach(key => url.searchParams.delete(key));
        url.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Event catalog could not be loaded');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('[data-event-catalog-groups]');
        if (!source) throw new Error('Event catalog missing');
        source.querySelectorAll('[data-event-id]').forEach(card => items.set(card.dataset.eventId, card));
      }
    } catch (error) {
      delete root.dataset.eventCatalogReady;
      return; // Keep the grouped server output and native source pagination usable.
    }
    const cards = [...items.values()].sort((a, b) => a.dataset.eventSortKey.localeCompare(b.dataset.eventSortKey));
    const legacyCards = [...cards].sort((a, b) => a.dataset.eventLegacySortKey.localeCompare(b.dataset.eventLegacySortKey));
    const groupOf = card => groupNames[Number(card.dataset.eventSortKey.split('-')[0])] || 'unknown';
    const views = groupNames.map(name => {
      const section = root.querySelector('[data-event-group="' + name + '"]');
      const grid = section.querySelector('[data-event-group-grid]');
      const groupCards = cards.filter(card => groupOf(card) === name);
      grid.replaceChildren(...groupCards);
      grid.hidden = groupCards.length === 0;
      const empty = section.querySelector('[data-event-empty]');
      if (empty) empty.hidden = groupCards.length > 0;
      section.hidden = (name === 'current' || name === 'unknown') && !groupCards.length && section.dataset.eventPinned !== 'true';
      const countLabel = section.querySelector('[data-event-group-count]');
      if (countLabel) countLabel.textContent = groupCards.length + (groupCards.length === 1 ? ' event post' : ' event posts');
      const nav = section.querySelector('[data-event-pagination]');
      return { name, section, cards: groupCards, nav, list: nav.querySelector('ul'), pages: Math.ceil(groupCards.length / 9) };
    });
    function pageNumber(value, count) {
      const number = /^\d+$/.test(value || '') ? Number(value) : 1;
      return Math.max(1, Math.min(count || 1, Number.isSafeInteger(number) ? number : 1));
    }
    function readState() {
      const url = new URL(location.href);
      const state = Object.fromEntries(views.map(view => [view.name, pageNumber(url.searchParams.get(pageKeys[view.name]), view.pages)]));
      let legacyTarget = null;
      if (url.searchParams.has('event_page') && !Object.values(pageKeys).some(key => url.searchParams.has(key)) && legacyCards.length) {
        const legacyPage = pageNumber(url.searchParams.get('event_page'), Math.ceil(legacyCards.length / 9));
        const firstCard = legacyCards[(legacyPage - 1) * 9];
        legacyTarget = views.find(view => view.name === groupOf(firstCard));
        state[legacyTarget.name] = Math.floor(legacyTarget.cards.indexOf(firstCard) / 9) + 1;
        url.searchParams.delete('event_page');
        url.searchParams.delete('page');
        url.searchParams.set(pageKeys[legacyTarget.name], state[legacyTarget.name]);
        url.hash = legacyTarget.section.id;
        history.replaceState(history.state, '', url);
      }
      return { state, legacyTarget };
    }
    function scrollToGroup(section) {
      const header = document.querySelector('.jpi-universal-header');
      section.style.scrollMarginTop = ((header ? header.getBoundingClientRect().height : 0) + 24) + 'px';
      section.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
    function display() {
      const { state, legacyTarget } = readState();
      views.forEach(view => {
        const page = state[view.name];
        view.cards.forEach((card, index) => {
          card.hidden = index < (page - 1) * 9 || index >= page * 9;
          card.style.setProperty('--animation-order', index % 9 + 1);
          card.classList.remove('scroll-trigger--offscreen');
        });
        view.list.replaceChildren();
        for (let number = 1; number <= view.pages; number++) {
          const item = document.createElement('li');
          const link = document.createElement('a');
          const url = new URL(location.href);
          url.searchParams.delete('page');
          url.searchParams.delete('event_page');
          url.searchParams.set(pageKeys[view.name], number);
          url.hash = view.section.id;
          link.href = url.href;
          link.textContent = number;
          link.setAttribute('aria-label', 'Page ' + number);
          link.className = 'pagination__item link' + (number === page ? ' pagination__item--current' : '');
          if (number === page) link.setAttribute('aria-current', 'page');
          link.addEventListener('click', event => {
            if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            history.pushState(history.state, '', link.href);
            display();
            scrollToGroup(view.section);
            view.list.querySelector('[aria-current="page"]')?.focus({ preventScroll: true });
          });
          item.append(link);
          view.list.append(item);
        }
        view.nav.hidden = view.pages <= 1;
      });
      if (legacyTarget) scrollToGroup(legacyTarget.section);
    }
    display();
    window.addEventListener('popstate', display);
    root.querySelector('[data-event-source-pagination]')?.setAttribute('hidden', '');
    root.dataset.eventCatalogReady = 'true';
  }
  document.querySelectorAll('[data-event-catalog-groups]').forEach(initializeGroupedEventCatalog);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-event-catalog-groups]').forEach(initializeGroupedEventCatalog));
  /* TIMESTAMP END 2026-10-25T19:35:41-04:00 | REVISION R000053 */
  /* TIMESTAMP START 2026-10-19T20:39:49-04:00 | REVISION R004394 */
  async function initializeEventCatalog(root) {
    if (root.dataset.eventCatalogReady) return;
    root.dataset.eventCatalogReady = 'loading';
    const grid = root.querySelector('.jpi-blog-grid');
    const nav = root.querySelector('[data-event-pagination]');
    const list = nav.querySelector('ul');
    const items = new Map([...grid.querySelectorAll('[data-event-id]')].map(item => [item.dataset.eventId, item]));
    try {
      for (let page = 1; page <= Number(root.dataset.sourcePages); page++) {
        if (page === Number(root.dataset.sourcePage)) continue;
        const url = new URL(location.href);
        url.searchParams.set('page', page);
        url.searchParams.delete('event_page');
        url.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Event catalog could not be loaded');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('[data-event-catalog]');
        if (!source) throw new Error('Event catalog missing');
        source.querySelectorAll('[data-event-id]').forEach(item => items.set(item.dataset.eventId, item));
      }
    } catch (error) {
      delete root.dataset.eventCatalogReady;
      return;
    }
    const cards = [...items.values()].sort((a, b) => a.dataset.eventSortKey.localeCompare(b.dataset.eventSortKey));
    const fragment = document.createDocumentFragment();
    cards.forEach(card => fragment.append(card));
    if (cards.length) grid.replaceChildren(fragment);
    const count = Math.ceil(cards.length / 9);
    function display(page, updateUrl) {
      page = Math.max(1, Math.min(count || 1, page));
      cards.forEach((card, index) => {
        card.hidden = index < (page - 1) * 9 || index >= page * 9;
        card.style.setProperty('--animation-order', index % 9 + 1);
        card.classList.remove('scroll-trigger--offscreen');
      });
      list.replaceChildren();
      for (let number = 1; number <= count; number++) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        const url = new URL(location.href);
        url.searchParams.delete('page');
        url.searchParams.set('event_page', number);
        url.hash = root.id;
        link.href = url.href;
        link.textContent = number;
        link.className = 'pagination__item link' + (number === page ? ' pagination__item--current' : '');
        if (number === page) link.setAttribute('aria-current', 'page');
        link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          display(number, true);
          root.scrollIntoView({ block: 'start' });
          list.querySelector('[aria-current="page"]').focus({ preventScroll: true });
        });
        item.append(link);
        list.append(item);
      }
      nav.hidden = count <= 1;
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.delete('page');
        url.searchParams.set('event_page', page);
        url.hash = root.id;
        history.pushState(null, '', url);
      }
    }
    const currentPage = () => Math.max(1, parseInt(new URL(location.href).searchParams.get('event_page'), 10) || 1);
    display(currentPage(), false);
    window.addEventListener('popstate', () => display(currentPage(), false));
    root.querySelector('[data-event-source-pagination]')?.setAttribute('hidden', '');
    root.dataset.eventCatalogReady = 'true';
  }
  document.querySelectorAll('[data-event-catalog]').forEach(initializeEventCatalog);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-event-catalog]').forEach(initializeEventCatalog));
  /* TIMESTAMP END 2026-10-19T20:39:49-04:00 | REVISION R004394 */

  } catch(e) { console.error(e); }
})();
})();
